module.exports = __webpack_public_path__ + "static/img/沒事啦300.817e9d05.png";